module.exports = ".modal-dialog {\n  width: 75%;\n  max-height: 95%;\n  max-width: none;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/limit-flow-proposal/component/summary/guarantee-modal/guarantee-modal.component.scss
// module id = ./src/app/limit-flow-proposal/component/summary/guarantee-modal/guarantee-modal.component.scss
// module chunks = main